import { useContext, useEffect, useState } from 'react';
import './ListsPage.scss';
import { AuthContext, ToastContext } from '../../context';
import { db } from '../../firebase';
import { deleteDoc, doc } from 'firebase/firestore';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { Page, Breadcrumb, List, Icon, SimpleDialog, Row } from '../../components';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const ListsPage = () => {
    const { user } = useContext(AuthContext);
    const { toast } = useContext(ToastContext);
    const navigate = useNavigate();
    const [ spellLists, setSpellLists ] = useState([]);
    const [ selectedListId, setSelectedListId ] = useState(null);
    const [ confirmDeleteOpen, setConfirmDeleteOpen ] = useState(false);

    useEffect(() => {
        if(user?.uid) {
            const q = query(collection(db, 'spellLists'), where('userId', '==', user?.uid));
            const unsub = onSnapshot(q, snapshot => 
                setSpellLists(snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                })))
            );

            return () => unsub();
        }
    }, [user?.uid]);

    const handleClickDelete = (list) => {
        setConfirmDeleteOpen(true);
        setSelectedListId(list.id);
    };

    const handleConfirmDelete = (value) => {
        setConfirmDeleteOpen(false);
        if (value === 'yes') {
            deleteList(selectedListId);
        }
        setSelectedListId(null);
    };

    const deleteList = (id) => {     
        const docRef = doc(db, "spellLists", id);

        deleteDoc(docRef).then(() => {
            toast('Successfully deleted list.');
        });
    }

    return (
        <Page className="ListsPage">
            <Breadcrumb />
            <h2>Lists</h2>
            <div className="body">
                {!spellLists.length && <p>Get started with Lists! When you make a list you can add spells to it and come back later.</p>}
                <List>
                    <Button 
                        variant='outlined' 
                        color="secondary"
                        onClick={() => {navigate('/lists/edit')}}
                    >
                        <Icon name="plus" size={12} />&nbsp; Create new list
                    </Button>
                    {spellLists.map(list => (
                        <Row key={list.id} >
                            <Button variant="contained" onClick={() => navigate(`${list.id}`)}>{list.name}</Button>
                            <Icon name="trash" size={18} onClick={() => handleClickDelete(list)} />
                        </Row>
                    ))}
                </List>
            </div>
            <SimpleDialog 
                title='Are you sure?'
                options={[
                    {key: 'yes', text: 'Yes, delete this list'},
                    {key: 'no', text: 'No, cancel'}
                ]}
                open={confirmDeleteOpen}
                onClose={handleConfirmDelete}
            />
        </Page>
    );
};